<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="list-product p-2">
        <!--
        <lib-crud
          [newLabel]="'Inventory'"
          [items]="AdminInventoryList"
          (actionHandler)="handleEvent($event)"
          (deleteActionHandler)="deleteRecord($event)"
          [closePopup]="closeFormEvent"
          [openEditPopup]="editRecord"
          [popupWidthPercent]="'80'"
          [popupTitle]="'Inventory '"
          [openDeletePopup]="openDeletePopup"
        >
          
          <form class="row" formsElement #AdminInventoryForm="ngForm">
            Action Buttons -->
            <div class="row mb-3">
              <div class="col-sm-1">
                <button type="button" class="btn btn-primary" (click)="openPurchaseOrder()">
                  Add Inventory
                </button>
              </div>
              <div class="col-sm-1">
                <button type="button" class="btn btn-success" (click)="openClinicSupply()">
                  Clinic Supply
                </button>
              </div>
            </div>

            <!-- Warehouse Inventory Table -->
            <div class="row">
              <div class="col-sm-12 bg-light-yellow">

                <!-- Fixed Header -->
                <table class="table table-bordered table-sm" style="table-layout: fixed; width: 100%;">
                  <thead>
                    <tr>
                      <th>Medicine</th>
                      <th>Qty</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                </table>

                <!-- Scrollable Body -->
                <p-scrollPanel [style]="{ width: '100%', maxhaight: '300px' }">
                  <table class="table table-bordered table-sm" style="table-layout: fixed; width: 100%;">
                    <tbody>
                      <tr *ngFor="let item of storeInventory['Warehouse']; trackBy: trackByFn">
                        <td>{{ item.itemName }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>
                          <p-tag
                            [severity]="getSeverity(item.status)"
                            [value]="item.status"
                          ></p-tag>
                        </td>
                        <td>
                          <button 
                            type="button" 
                            class="btn btn-sm btn-secondary" 
                            (click)="openPoHistoryPopup(item, 'Warehouse')"
                          >
                            History
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </p-scrollPanel>

              </div>
            </div>
          <!-- </form>
        </lib-crud> -->
      </div>
    </div>
  </div>
</div>

<!-- Purchase Order Popup -->
<p-dialog 
  header="Add Inventory" 
  [(visible)]="isPurchaseOrderVisible" 
  [modal]="true" 
  [style]="{ width: '600px' }"
  (onHide)="closePurchaseOrder()"
>
  <app-purchase-order></app-purchase-order>
  <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn btn-primary" (click)="closePurchaseOrder()">Add</button>
  </div>
</p-dialog>

<!-- Clinic Supply Popup -->
<p-dialog 
  header="Clinic Supply" 
  [(visible)]="isClinicSupplyVisible" 
  [modal]="true" 
  [style]="{ width: '600px' }"
  (onHide)="closeClinicSupply()"
>
  <app-clinic-supply></app-clinic-supply>
  <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn btn-success" (click)="closeClinicSupply()">Supply</button>
  </div>
</p-dialog>

<!-- PO History Popup -->
<!-- 

<p-dialog
  header="PO History"
  [(visible)]="isHistoryPopupVisible"
  [modal]="true"
  [style]="{ width: '600px' }"
  (onHide)="closeHistoryPopup()"
>
<div>
  <div *ngIf="selectedItem">
    <h5>{{ selectedItem.itemName }} - History</h5>
   
  </div>
  </div>
  <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn btn-secondary" (click)="closeHistoryPopup()">ok</button>
  </div>
</p-dialog> -->

<!-- PO History Popup -->

<p-dialog
  header="PO History"
  [(visible)]="isHistoryPopupVisible"
  [modal]="true"
  [style]="{ width: '800px' }"
  (onHide)="closeHistoryPopup()"
>
  <div *ngIf="selectedItem">

    <h5 class="mb-3">{{ selectedItem.itemName }} - Transaction History</h5>

    <!-- PARACETAMOL -->
    <table *ngIf="selectedItem.itemName === 'Paracetamol ( 100 ml )'" class="table table-bordered table-sm">
      <thead class="table-light">
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Location</th>
          <th>Old</th>
          <th>Change</th>
          <th>Total</th>
        </tr>
      </thead>
        <tbody>
        <tr class="bg-light-green"><td>01/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>0</td><td class="text-success">+100</td><td>100</td></tr>
        <tr class="bg-light-yellow"><td>05/05/2025</td><td>Clinic Supply</td><td>Clinic 1</td><td>100</td><td class="text-danger">-20</td><td>80</td></tr>
        <tr class="bg-light-yellow"><td>10/05/2025</td><td>Clinic Supply</td><td>Clinic 2</td><td>80</td><td class="text-danger">-15</td><td>65</td></tr>
        <tr class="bg-light-yellow"><td>12/05/2025</td><td>Clinic Supply</td><td>Clinic 3</td><td>65</td><td class="text-danger">-10</td><td>55</td></tr>
        <tr class="bg-light-green"><td>15/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>55</td><td class="text-success">+45</td><td>100</td></tr>
        <tr class="bg-light-yellow"><td>18/05/2025</td><td>Clinic Supply</td><td>Clinic 1</td><td>100</td><td class="text-danger">-25</td><td>75</td></tr>
        <tr class="bg-light-yellow"><td>20/05/2025</td><td>Clinic Supply</td><td>Clinic 2</td><td>75</td><td class="text-danger">-10</td><td>65</td></tr>
        <tr class="bg-light-yellow"><td>22/05/2025</td><td>Clinic Supply</td><td>Clinic 3</td><td>65</td><td class="text-danger">-15</td><td>50</td></tr>
        <tr class="bg-light-green"><td>25/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>50</td><td class="text-success">+50</td><td>100</td></tr>
      </tbody>
    </table>

    <!-- IBUPROFEN -->
    <table *ngIf="selectedItem.itemName === 'Paracetamol ( 30 ml )'" class="table table-bordered table-sm">
      <thead class="table-light">
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Location</th>
          <th>Old</th>
          <th>Change</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr class="bg-light-green"><td>02/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>0</td><td class="text-success">+40</td><td>40</td></tr>
        <tr class="bg-light-yellow"><td>06/05/2025</td><td>Clinic Supply</td><td>Clinic 1</td><td>40</td><td class="text-danger">-5</td><td>35</td></tr>
        <tr class="bg-light-yellow"><td>09/05/2025</td><td>Clinic Supply</td><td>Clinic 2</td><td>35</td><td class="text-danger">-10</td><td>25</td></tr>
        <tr class="bg-light-green"><td>14/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>25</td><td class="text-success">+35</td><td>60</td></tr>
      </tbody>
    </table>

    <!-- AMOXICILLIN -->
    <table *ngIf="selectedItem.itemName === 'Paracetamol ( 10 ml )'" class="table table-bordered table-sm">
      <thead class="table-light">
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Location</th>
          <th>Old</th>
          <th>Change</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr class="bg-light-green"><td>05/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>0</td><td class="text-success">+30</td><td>30</td></tr>
        <tr class="bg-light-yellow"><td>08/05/2025</td><td>Clinic Supply</td><td>Clinic 3</td><td>30</td><td class="text-danger">-5</td><td>25</td></tr>
        <tr class="bg-light-green"><td>13/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>25</td><td class="text-success">+20</td><td>45</td></tr>
      </tbody>
    </table>

    <!-- CETIRIZINE -->
    <table *ngIf="selectedItem.itemName === 'Cough Syrup ( 100 ml )'" class="table table-bordered table-sm">
      <thead class="table-light">
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Location</th>
          <th>Old</th>
          <th>Change</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr class="bg-light-green"><td>03/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>0</td><td class="text-success">+50</td><td>50</td></tr>
        <tr class="bg-light-yellow"><td>06/05/2025</td><td>Clinic Supply</td><td>Clinic 2</td><td>50</td><td class="text-danger">-10</td><td>40</td></tr>
        <tr class="bg-light-yellow"><td>08/05/2025</td><td>Clinic Supply</td><td>Clinic 1</td><td>40</td><td class="text-danger">-10</td><td>30</td></tr>
        <tr class="bg-light-green"><td>15/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>30</td><td class="text-success">+50</td><td>80</td></tr>
      </tbody>
    </table>

    <!-- AZITHROMYCIN -->
    <table *ngIf="selectedItem.itemName === 'Cough Syrup ( 30 ml )'" class="table table-bordered table-sm">
      <thead class="table-light">
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Location</th>
          <th>Old</th>
          <th>Change</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr class="bg-light-green"><td>06/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>0</td><td class="text-success">+20</td><td>20</td></tr>
        <tr class="bg-light-yellow"><td>10/05/2025</td><td>Clinic Supply</td><td>Clinic 1</td><td>20</td><td class="text-danger">-5</td><td>15</td></tr>
        <tr class="bg-light-green"><td>12/05/2025</td><td>Add Inventory</td><td>Warehouse</td><td>15</td><td class="text-success">+15</td><td>30</td></tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-end mt-3">
      <button type="button" class="btn btn-secondary" (click)="closeHistoryPopup()">Close</button>
    </div>

  </div>
</p-dialog>
